import { type FC } from "react";
import { type UserSimple } from "@src/types";
import { ArticleLeftArea, ArticleRightArea } from "../macroComponent/Article";
import { User } from "@supabase/supabase-js";
import { UserInterface } from "@src/utils/types";
// import { UserInterface } from "~/utils/SupabaseAuthContext";

const ArticleHeader = ({ user }: { user: UserInterface }) => {
  return (
    <header className="w-full border-b border-border-light bg-white dark:border-border dark:bg-primary">
      <div className="mx-auto flex max-w-[1550px] items-center justify-between gap-4 px-4 py-4">
        <div className="flex flex-1 items-center justify-between gap-8 md:gap-4">
          <ArticleLeftArea user={user} />
          <ArticleRightArea user={user} />
        </div>
      </div>
    </header>
  );
};

export default ArticleHeader;
